<template>
  <div></div>
</template>
<script>
  export default {
    mounted () {
      this.$store.commit('setUserToken', this.$route.params.token)
      this.$store.commit('clearForm',{})
      this.$getUser()
      if (this.$store.state.lastPage) {
        this.$router.replace(this.$store.state.lastPage)
      }
    }
  }
</script>
